import { useState } from 'react';
import './NewTrademarkApplicationForm.css';
import { createTrademarkApplication } from '../../utilities/api/trademarkApplications';


export default function NewTrademarkApplicationForm({user, checkForClient, updateTrademarkApplications, toggleNotifications}) {
    const defaultState = {
        clientName: '',
        clientID: '',
        applicationType: '',
        RPNumber: '',
        filingFirm: '',
        firmRefNumber: '',
        contact: '',
        applicants: '',
        applicantAddress: '',
        trademarkClasses: '',
        highlyRelevantTrademarkClass: '',
        trademarkType: '',
        applicationNumber: '',
        filing: '',
        filingDate: '',
        trademarkDescription: '',
        priorityDate: '',
        priorityApplication: '',
        registrationNumber: '',
        registrationDate: '',
        feesPaid: '',
        nationalEntryDate: '',
        applicationStatus: '',
        examinationByOffice: '',
        approvalOrDenial: '',
        NOA: '',
        maintenanceOfRegistration: '',
        lastAction: '',
        nextAction: '',
        nextActionDueDate: '',
        notes: '',
        driveFolderLocation: '',
        trademarkClassesForSearch: '',
        trademarkClassesForFiling: '',
    }
    const [formData, setFormData] = useState(defaultState)
    const rpNumberReg = /^([A-Z]{2}-[0-9]{4}\.[0-9]{2,}\.[0-9]{3}.*)$/
    const [isValidRPNumber, setIsValidRPNumber] = useState(false)
    const [isSubmitting, setIsSubmitting] = useState(false)

    const handleSubmit = async (evt) =>{
        evt.preventDefault();
        setIsSubmitting(true)
        try {
            const updatedTrademarkApplicationList = await createTrademarkApplication(formData)
            updateTrademarkApplications(updatedTrademarkApplicationList)
            await toggleNotifications('success', `New Trademark Application "${formData.applicationNumber}" Created!`, '#FFFFFF')
            setFormData(defaultState)
            document.getElementById('newTrademarkApplicationForm').reset()
        } catch (error) {
            console.log(error)
            await toggleNotifications('error', `Failed to Create Trademark Application "${formData.applicationNumber}"!`, '#FFFFFF')
        }
        setIsSubmitting(false)
    }

    

    async function handleChange(evt) {
        const newFormData = {
          ...formData,
          [evt.target.name]: evt.target.value,
        }

        if (evt.target.name === 'RPNumber') {
            await checkRPNumber(evt)
        }

        setFormData(newFormData);
        
        if (evt.target.name === 'clientID') {
            const clientID = evt.target.value
            if (clientID) {
                // Use async/await in an IIFE (Immediately Invoked Function Expression) to avoid blocking UI
                (async () => {
                    try {
                        const client = await checkForClient(clientID);
                        setFormData(prevFormData => ({
                            ...prevFormData,
                            clientName: client ? client.companyName : ''
                        }));
                    } catch (error) {
                        console.error('Error checking for client:', error);
                        setFormData(prevFormData => ({
                            ...prevFormData,
                            clientName: ''
                        }));
                    }
                })();
            } else {
                setFormData(prevFormData => ({
                    ...prevFormData,
                    clientName: ''
                }));
            }
        }
    }

    const checkRPNumber = async (evt) => {
        const rpNumber = evt.target.value
        rpNumberReg.test(rpNumber) ? setIsValidRPNumber(true) : setIsValidRPNumber(false)
    }



    const disabled = !formData.clientName || !formData.clientID || !formData.RPNumber || !isValidRPNumber || !formData.applicationNumber || !formData.filingDate
  return (
    <div className='NewTrademarkApplicationForm'>
        <form onSubmit={handleSubmit} id={`newTrademarkApplicationForm`}>
            <div className='formContent'>
                <div className='form-group'>
                    <label htmlFor={`trademark-clientID`} className='form-label'>Client ID <span className='requiredField'><strong>*</strong></span></label>
                    <input type="number" min={0} id={`trademark-clientID`} name='clientID' className='form-control' value={formData.clientID} onChange={handleChange}/>
                </div>
                <div className='form-group'>
                    <label htmlFor={`trademark-clientName`} className='form-label'>Client Name <span className='requiredField'><strong>*</strong></span></label>
                    <input type="text" id={`trademark-clientName`} name='clientName' className='form-control' value={formData.clientName} onChange={handleChange}/>
                </div>
                <div className='form-group rpNumber'>
                    <div className='input'>
                        <label htmlFor={`trademark-RPNumber`} className='form-label'>RP Number <span className='requiredField'><strong>*</strong></span></label>
                        <input type="text" id={`trademark-RPNumber`} name='RPNumber' className='form-control' defaultValue={formData.RPNumber} onChange={handleChange}/>
                    </div>
                    <div className='rpNumberStatus'>
                        <small className="form-text checkIsValidRPNumber" style={{backgroundColor:`${isValidRPNumber? 'green' : 'red'}`, color:'white'}}>Format: XX-0000.00.000</small>
                    </div>
                </div>
                <div className='form-group'>
                    <label htmlFor={`trademark-trademarkApplicationType`} className='form-label'>Application Type</label>
                    <select id={`trademark-trademarkApplicationType`} name='applicationType' className='form-select' value={formData.applicationType} onChange={handleChange}>
                        <option value="">---Select Application Type---</option>
                        <option value="US">US</option>
                        <option value="canadian">Canadian</option>
                        <option value="other">Other</option>
                    </select>
                </div>
                <div className='form-group'>
                    <label htmlFor={`trademark-filingFirm`} className='form-label'>Filing Firm</label>
                    <input type="text" id={`trademark-filingFirm`} name='filingFirm' className='form-control' value={formData.filingFirm} onChange={handleChange}/>
                </div>
                <div className='form-group'>
                    <label htmlFor={`trademark-firmRefNumber`} className='form-label'>Filing Firm Ref Number</label>
                    <input type="text" id={`trademark-firmRefNumber`} name='firmRefNumber' className='form-control' value={formData.firmRefNumber} onChange={handleChange}/>
                </div>
                <div className='form-group'>
                    <label htmlFor={`trademark-contact`} className='form-label'>Client Contact</label>
                    <input type="text" id={`trademark-contact`} name='contact' className='form-control' value={formData.contact} onChange={handleChange}/>
                </div>
                <div className='form-group'>
                    <label htmlFor={`trademark-applicants`} className='form-label'>Applicants</label>
                    <input type="text" id={`trademark-applicants`} name='applicants' className='form-control' value={formData.applicants} onChange={handleChange}/>
                </div>
                <div className='form-group'>
                    <label htmlFor={`trademark-applicantAddress`} className='form-label'>Applicant Address</label>
                    <input type="text" id={`trademark-applicantAddress`} name='applicantAddress' className='form-control' value={formData.applicantAddress} onChange={handleChange}/>
                </div>
                <div className='form-group'>
                    <label htmlFor={`trademark-trademarkClasses`} className='form-label'>Trademark Classes</label>
                    <input type="text" id={`trademark-trademarkClasses`} name='trademarkClasses' className='form-control' value={formData.trademarkClasses} onChange={handleChange}/>
                </div>
                <div className='form-group'>
                    <label htmlFor={`trademark-trademarkType`} className='form-label'>Trademark Type</label>
                    <select id={`trademark-trademarkType`} name='trademarkType' className='form-select' value={formData.trademarkType} onChange={handleChange}>
                        <option value="">---Select Trademark Type---</option>
                        <option value="word">Word</option>
                        <option value="image">Image</option>
                        <option value="design">Design</option>
                        <option value="composite">Composite</option>
                    </select>
                </div>
                <div className='form-group'>
                    <label htmlFor={`trademark-applicationNumber`} className='form-label'>Application Number <span className='requiredField'><strong>*</strong></span></label>
                    <input type="text" id={`trademark-applicationNumber`} name='applicationNumber' className='form-control' value={formData.applicationNumber} onChange={handleChange}/>
                </div>
                <div className='form-group'>
                    <label htmlFor={`trademark-filing`} className='form-label'>Filing Basis</label>
                    <select id={`trademark-filing`} name='filing' className='form-select' value={formData.filing} onChange={handleChange}>
                        <option value="">---Select Filing Type---</option>
                        <option value="useInCommerce">Use in Commerce</option>
                        <option value="intentToUse">Intent to Use</option>
                        <option value="baseApplication">Base Application</option>
                        <option value="foreignPriority">Foreign Priority</option>
                        <option value="foreignRegistration">Foreign Registration</option>
                        <option value="internationalFiling">International Filing</option>
                    </select>
                </div>
                <div className='form-group'>
                    <label htmlFor={`trademark-trademarkDescription`} className='form-label'>Trademark Description</label>
                    <textarea id={`trademark-trademarkDescription`} name='trademarkDescription' className='form-control' value={formData.trademarkDescription} onChange={handleChange}/>
                </div>
                <div className='form-group'>
                    <label htmlFor={`trademark-priorityDate`} className='form-label'>Priority Date</label>
                    <input type="date" id={`trademark-priorityDate`} name='priorityDate' className='form-control' value={formData.priorityDate} onChange={handleChange}/>
                </div>
                <div className='form-group'>
                    <label htmlFor={`trademark-priorityApplication`} className='form-label'>Priority Application</label>
                    <input type="text" id={`trademark-priorityApplication`} name='priorityApplication' className='form-control' value={formData.priorityApplication} onChange={handleChange}/>
                </div>
                <div className='form-group'>
                    <label htmlFor={`trademark-filingDate`} className='form-label'>Filing Date <span className='requiredField'><strong>*</strong></span></label>
                    <input type="date" id={`trademark-filingDate`} name='filingDate' className='form-control' value={formData.filingDate} onChange={handleChange}/>
                </div>
                <div className='form-group'>
                    <label htmlFor={`trademark-registrationNumber`} className='form-label'>Registration Number</label>
                    <input type="text" id={`trademark-registrationNumber`} name='registrationNumber' className='form-control' value={formData.registrationNumber} onChange={handleChange}/>
                </div>
                <div className='form-group'>
                    <label htmlFor={`trademark-registrationDate`} className='form-label'>Registration Date</label>
                    <input type="date" id={`trademark-registrationDate`} name='registrationDate' className='form-control' value={formData.registrationDate} onChange={handleChange}/>
                </div>
                <div className='form-group'>
                    <label htmlFor={`trademark-feesPaid`} className='form-label'>Fees Paid</label>
                    <select id={`trademark-feesPaid`} name='feesPaid' className='form-select' value={formData.feesPaid} onChange={handleChange}>
                        <option value="">---Select Option---</option>
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                    </select>
                </div>
                <div className='form-group'>
                    <label htmlFor={`trademark-nationalEntryDate`} className='form-label'>National Entry Date</label>
                    <input type="date" id={`trademark-nationalEntryDate`} name='nationalEntryDate' className='form-control' value={formData.nationalEntryDate} onChange={handleChange}/>
                </div>
                <div className='form-group'>
                    <label htmlFor={`trademark-applicationStatus`} className='form-label'>Application Status</label>
                    <select id={`trademark-applicationStatus`} name='applicationStatus' className='form-select' value={formData.applicationStatus} onChange={handleChange}>
                        <option value="">---Select Application Status---</option>
                        <option value="new">New</option>
                        <option value="officeActionIssued">Office Action Issued</option>
                        <option value="filed">Filed</option>
                        <option value="formalized">Formalized</option>
                        <option value="awaitingExam">Awaiting Exam</option>
                        <option value="examReportIssued">Exam Report Issued</option>
                        <option value="approved">Approved</option>
                        <option value="NOAIssued">NOA Issued</option>
                        <option value="advertised">Advertised</option>
                        <option value="registered">Registered</option>
                        <option value="opposed">Opposed</option>
                        <option value="abandoned">Abandoned</option>
                        <option value="allowed">Allowed</option>
                        <option value="cancelled">Cancelled</option>
                    </select>
                </div>
                <div className='form-group'>
                    <label htmlFor={`trademark-examinationByOffice`} className='form-label'>Examination By Office</label>
                    <select id={`trademark-examinationByOffice`} name='examinationByOffice' className='form-select' value={formData.examinationByOffice} onChange={handleChange}>
                        <option value="">---Select Option---</option>
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                    </select>
                </div>
                <div className='form-group'>
                    <label htmlFor={`trademark-approvalOrDenial`} className='form-label'>Approval or Denial</label>
                    <select id={`trademark-approvalOrDenial`} name='approvalOrDenial' className='form-select' value={formData.approvalOrDenial} onChange={handleChange}>
                        <option value="">---Select Option---</option>
                        <option value="approved">Approved</option>
                        <option value="denied">Denied</option>
                    </select>
                </div>
                <div className='form-group'>
                    <label htmlFor={`trademark-NOA`} className='form-label'>NOA</label>
                    <select id={`trademark-NOA`} name='NOA' className='form-select' value={formData.NOA} onChange={handleChange}>
                        <option value="">---Select Option---</option>
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                    </select>
                </div>
                <div className='form-group'>
                    <label htmlFor={`trademark-maintenanceOfRegistration`} className='form-label'>Maintenance of Registration</label>
                    <select id={`trademark-maintenanceOfRegistration`} name='maintenanceOfRegistration' className='form-select' value={formData.maintenanceOfRegistration} onChange={handleChange}>
                        <option value="">---Select Option---</option>
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                    </select>
                </div>
                <div className='form-group'>
                    <label htmlFor={`trademark-lastAction`} className='form-label'>Last Action</label>
                    <input type="text" id={`trademark-lastAction`} name='lastAction' className='form-control' value={formData.lastAction} onChange={handleChange}/>
                </div>
                <div className='form-group'>
                    <label htmlFor={`trademark-nextAction`} className='form-label'>Next Action</label>
                    <input type="text" id={`trademark-nextAction`} name='nextAction' className='form-control' value={formData.nextAction} onChange={handleChange}/>
                </div>
                <div className='form-group'>
                    <label htmlFor={`trademark-nextActionDueDate`} className='form-label'>Next Action Due Date</label>
                    <input type="date" id={`trademark-nextActionDueDate`} name='nextActionDueDate' className='form-control' value={formData.nextActionDueDate} onChange={handleChange}/>
                </div>
                <div className='form-group'>
                    <label htmlFor={`trademark-notes`} className='form-label'>Notes</label>
                    <textarea id={`trademark-notes`} name='notes' className='form-control' value={formData.notes} onChange={handleChange}/>
                </div>
                <div className='form-group'>
                    <label htmlFor={`trademark-driveFolderLocation`} className='form-label'>Folder Location</label>
                    <input type="text" id={`trademark-driveFolderLocation`} name='driveFolderLocation' className='form-control' value={formData.driveFolderLocation} onChange={handleChange}/>
                </div>
                <div className='form-group'>
                    <label htmlFor={`trademark-trademarkClassesForSearch`} className='form-label'>Trademark Classes For Search</label>
                    <input type="text" id={`trademark-trademarkClassesForSearch`} name='trademarkClassesForSearch' className='form-control' value={formData.trademarkClassesForSearch} onChange={handleChange}/>
                </div>
                <div className='form-group'>
                    <label htmlFor={`trademark-trademarkClassesForFiling`} className='form-label'>Trademark Classes For Filing</label>
                    <input type="text" id={`trademark-trademarkClassesForFiling`} name='trademarkClassesForFiling' className='form-control' value={formData.trademarkClassesForFiling} onChange={handleChange}/>
                </div>
            </div>
        </form>
        <div className='formButtonContainer'>
            <button data-bs-dismiss="modal" className='cancel'>
                Cancel
            </button>
            <button data-bs-dismiss="modal" className="submit" type="submit" form={`newTrademarkApplicationForm`} disabled={disabled||isSubmitting}>
                Add Application
            </button>
        </div>
    </div>
  )
}
